
export class ConfiguracaoModalInfoAgrupamento {

  title: string;
  subtitle: string;
  itens?: any;
  numeroColunas?: number = 4;

}
